import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function AlertDialog(props) {
  const [open, setOpen] = React.useState(props.open);

  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        disableBackdropClick
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure you want to leave the page?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You have unsaved changes
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.navigatingnext &&
            <span>
              <Button onClick={(e) => props.nextItem(e, true)} color="primary" autoFocus>
                Leave
          </Button>
              <Button onClick={(e) => props.nextItem(e, false, true)} color="primary">
                Stay
          </Button>
            </span>
          }
           {props.navigatingprev &&
            <span>
              <Button onClick={(e) => props.prevItem(e, true)} color="primary" autoFocus>
                Leave
          </Button>
              <Button onClick={(e) => props.prevItem(e, false, true)} color="primary">
                Stay
          </Button>
            </span>
          }
          {!props.navigatingnext && !props.navigatingprev &&
          <span>
          <Button onClick={(e) => props.handleBack(e, true)} color="primary" autoFocus>
            Leave
          </Button>
          <Button onClick={(e) => props.handleBack(e, false, true)} color="primary">
            Stay
          </Button>
          </span>}
        </DialogActions>
      </Dialog>
    </div>
  );
}
